<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Usuario" resource="usuarios" primaryKey="idusuario" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import UsuarioService from "@/services/usuario.service";
import { usuario } from "@/models/usuario";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: usuario,
      service: UsuarioService
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        UsuarioService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
